/* unplugin-vue-components disabled */import { render } from "./SimpleCheckbox.vue?vue&type=template&id=983a83c2&scoped=true"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=js"

import "./SimpleCheckbox.vue?vue&type=style&index=0&id=983a83c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983a83c2"]])

export default __exports__